/**
 * ¿Tiene este usuario MÁS DE UNA empresa?
 *
 * Es la pregunta que hay que hacerse para decidir si se enseña el filtro de
 * empresa, y durante mucho tiempo se contestó con `useIsEmpresaAll`, que es
 * otra cosa. Las dos coinciden en los extremos —quien tiene `Empresa.All` ve
 * cuatro, y quien tiene una sola no necesita elegir— pero se separan justo en
 * el medio: alguien con `Empresa.AVI` + `Empresa.TDIS` tiene dos empresas,
 * necesita el desplegable y no lo veía. Trabajaba con los datos de las dos
 * mezclados y sin forma de separarlos.
 *
 * El cambio sólo AÑADE: quien veía el filtro lo sigue viendo (`Empresa.All`
 * son cuatro empresas), y lo gana quien tiene dos o tres.
 *
 * NO sirve para restringir. Hay sitios donde `isEmpresaAll` es una restricción
 * de ROL de verdad y no un «cuántas empresas tengo» —el motivo de desviación de
 * producción diaria es el caso claro, y está dicho en su comentario—. Ahí
 * cambiarlo enseñaría un dato a quien no debe verlo.
 */
import { useAllowedEmpresas } from '@/hooks/useAllowedEmpresas'

export function useVariasEmpresas(): boolean {
  // Mientras `/auth/me` no ha contestado la lista viene vacía y esto es
  // `false`: el filtro aparece al llegar la respuesta. Es el orden correcto —
  // un desplegable de empresa sin empresas dentro no sirve para nada.
  return useAllowedEmpresas().length > 1
}
